import './RequestGroup.scss';
import { prefixClass } from 'lib/utils';
import RequestItem from '../RequestItem';
import { AskRequest } from '@hone-automation/common';
import RequestGroupHeader from './RequestGroupHeader';
import classNames from 'classnames';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { useQueueContext } from '../QueueContext';

type RequestGroupProps = {
  collapsed?: boolean;
  blocker?: boolean;
  requests: AskRequest[];
  title: string;
  multiLocation: boolean;
  onRequestClick?: (id: string) => void;
};

const RequestGroup = ({
  collapsed,
  requests,
  title,
  multiLocation = false,
  onRequestClick,
  blocker,
}: RequestGroupProps) => {
  if (!requests || !requests.length) throw new Error('No data');

  const { state, dispatch } = useQueueContext();
  const isCollapsed = state.collapsedGroups[title] !== undefined ? state.collapsedGroups[title] : collapsed;
  const numRequests = requests.length;
  const prefix = prefixClass('request-group');
  const [parent] = useAutoAnimate({
    duration: 200,
  });

  const onCollapse = () => {
    dispatch({
      type: 'SET_GROUP_COLLAPSED',
      payload: { groupId: title, isCollapsed: !isCollapsed },
    });
  };
  const handleClick = (id: string) => {
    onRequestClick && onRequestClick(id);
  };

  return (
    <div className={prefix()}>
      <RequestGroupHeader title={title} numRequests={numRequests} collapsed={isCollapsed} onCollapse={onCollapse} />
      <div ref={parent} className={classNames(prefix('list'), { 'list-collapsed': isCollapsed })}>
        {requests.map((request, index) => {
          return (
            <RequestItem
              blocker={blocker}
              key={request.id}
              request={request}
              onClick={handleClick}
              multiLocation={multiLocation}
              read={true}
              me={false}
            />
          );
        })}
      </div>
    </div>
  );
};

export default RequestGroup;
